/* Herb24 — Cart drawer (AJAX) */
(function() {
  'use strict';
  const FREE_SHIP_TWD = 1500;

  const drawer = document.getElementById('cartDrawer');
  if (!drawer) return;

  function openDrawer() {
    drawer.hidden = false;
    requestAnimationFrame(() => drawer.classList.add('is-open'));
    document.body.style.overflow = 'hidden';
  }
  window.closeCartDrawer = function() {
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(() => { drawer.hidden = true; }, 300);
  };
  function toggleDrawer() {
    if (drawer.classList.contains('is-open')) closeCartDrawer();
    else openDrawer();
  }

  // ===== AJAX cart helpers =====
  async function getCart() {
    const r = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    return r.json();
  }
  async function addToCart(formData) {
    const r = await fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'Accept': 'application/json' },
    });
    if (!r.ok) {
      const err = await r.json().catch(() => ({}));
      throw new Error(err.description || 'Add to cart failed');
    }
    return r.json();
  }
  async function changeQty(key, quantity) {
    const r = await fetch('/cart/change.js', {
      method: 'POST',
      body: JSON.stringify({ id: key, quantity }),
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    });
    return r.json();
  }

  // ===== Format helpers =====
  function formatTWD(cents) {
    return 'NT$ ' + Math.round(cents / 100).toLocaleString('en-US');
  }

  // ===== Render =====
  function renderDrawer(cart) {
    // Header count
    const countEl = document.getElementById('cdCount');
    if (countEl) countEl.textContent = '(' + cart.item_count + ')';

    // Shipping bar
    const shipBar = document.getElementById('cdShipBar');
    if (shipBar) {
      const remaining = (FREE_SHIP_TWD * 100) - cart.total_price;
      const progress = Math.min(100, Math.round(cart.total_price / (FREE_SHIP_TWD * 100) * 100));
      if (cart.item_count === 0) {
        shipBar.innerHTML = `
          <div class="cart-drawer__ship-msg">滿 NT$ 1,500 享免運</div>
          <div class="cart-drawer__ship-bar"><div class="cart-drawer__ship-fill" style="width:0%"></div></div>`;
      } else if (remaining > 0) {
        shipBar.innerHTML = `
          <div class="cart-drawer__ship-msg">再 NT$ ${Math.ceil(remaining / 100).toLocaleString('en-US')} 即可享免運</div>
          <div class="cart-drawer__ship-bar"><div class="cart-drawer__ship-fill" style="width:${progress}%"></div></div>`;
      } else {
        shipBar.innerHTML = `
          <div class="cart-drawer__ship-msg cart-drawer__ship-msg--free">✓ 已達免運條件</div>
          <div class="cart-drawer__ship-bar"><div class="cart-drawer__ship-fill" style="width:100%"></div></div>`;
      }
    }

    // Items list
    const items = document.getElementById('cdItems');
    if (items) {
      if (cart.item_count === 0) {
        items.innerHTML = `
          <div class="cart-drawer__empty">
            <p>購物車是空的</p>
            <button type="button" class="btn btn-ghost" onclick="closeCartDrawer()">繼續購物</button>
          </div>`;
      } else {
        items.innerHTML = cart.items.map(item => `
          <div class="cart-drawer__item" data-key="${item.key}">
            <a href="${item.url}" class="cart-drawer__img">
              ${item.image ? `<img src="${item.image.replace(/_(\d+)x\./, '_200x.')}" alt="" width="100" height="100" loading="lazy">` : ''}
            </a>
            <div class="cart-drawer__body">
              <div class="cart-drawer__name"><a href="${item.url}">${escapeHtml(item.product_title)}</a></div>
              ${item.variant_title && !item.variant_title.includes('Default') ? `<div class="cart-drawer__variant">${escapeHtml(item.variant_title)}</div>` : ''}
              <div class="cart-drawer__row">
                <div class="cart-drawer__qty">
                  <button type="button" aria-label="減少" onclick="cdQty('${item.key}', ${item.quantity - 1})">−</button>
                  <span>${item.quantity}</span>
                  <button type="button" aria-label="增加" onclick="cdQty('${item.key}', ${item.quantity + 1})">+</button>
                </div>
                <div class="cart-drawer__price">${formatTWD(item.final_line_price)}</div>
              </div>
              <button type="button" class="cart-drawer__remove" onclick="cdQty('${item.key}', 0)">移除</button>
            </div>
          </div>`).join('');
      }
    }

    // Footer
    const foot = drawer.querySelector('.cart-drawer__foot');
    if (foot) {
      foot.hidden = cart.item_count === 0;
      const sub = document.getElementById('cdSubtotal');
      if (sub) sub.textContent = formatTWD(cart.total_price);
    }

    // Header cart icon badge
    const badge = document.querySelector('.header-icons .cart-count');
    if (badge) {
      badge.textContent = cart.item_count;
      badge.style.display = cart.item_count > 0 ? '' : 'none';
    } else if (cart.item_count > 0) {
      // Inject badge if missing
      const cartBtn = document.querySelector('.header-icons a[href*="cart"]');
      if (cartBtn && !cartBtn.querySelector('.cart-count')) {
        const span = document.createElement('span');
        span.className = 'cart-count';
        span.textContent = cart.item_count;
        cartBtn.appendChild(span);
      }
    }
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c]);
  }

  // ===== Qty change (called from drawer markup via inline onclick) =====
  window.cdQty = async function(key, quantity) {
    try {
      const cart = await changeQty(key, Math.max(0, quantity));
      renderDrawer(cart);
    } catch (e) {
      console.error('cart change failed', e);
    }
  };

  // ===== Wire it all up =====
  document.addEventListener('DOMContentLoaded', function() {
    // 1. Header cart icon → open drawer instead of navigating
    document.querySelectorAll('.header-icons a[href*="cart"], a[href="/cart"]').forEach(link => {
      link.addEventListener('click', function(e) {
        // Allow Cmd/Ctrl-click to still navigate
        if (e.metaKey || e.ctrlKey || e.shiftKey) return;
        e.preventDefault();
        getCart().then(c => { renderDrawer(c); openDrawer(); });
      });
    });

    // 2. Add-to-Cart forms → AJAX add + open drawer
    document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
      form.addEventListener('submit', async function(e) {
        e.preventDefault();
        const submitBtn = form.querySelector('[type="submit"]');
        if (submitBtn) { submitBtn.disabled = true; submitBtn.dataset._label = submitBtn.textContent; submitBtn.textContent = '加入中...'; }
        try {
          await addToCart(new FormData(form));
          const cart = await getCart();
          renderDrawer(cart);
          openDrawer();
        } catch (err) {
          alert(err.message || '無法加入購物車，請再試一次');
        } finally {
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = submitBtn.dataset._label || '加入購物車'; }
        }
      });
    });

    // 3. Close drawer on Escape
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeCartDrawer();
    });
  });
})();
